import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Manager, Target, Popper, Arrow } from 'react-popper';
import { IS_TOUCHSCREEN } from '../../helpers/detect-device';
import { stopPropagation } from '../../helpers/utils';
import { makeBodyHeightAuto, unmakeBodyHeightAuto } from '../../helpers/body-helper';
import { SSR } from '../../helpers/ssr';
const h = React.createElement;
export default class Tooltip extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    content: PropTypes.string,
    children: PropTypes.any,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
  };
  static popperModifiers = SSR ? {} : {
    preventOverflow: {
      boundariesElement: document.body
    }
  };
  static defaultProps = {
    placement: 'top'
  };
  state = SSR ? {
    isReady: true,
    isShown: false
  } : {
    isReady: false,
    isShown: false
  };
  componentDidMount = () => {
    this.setState({
      isReady: true
    });
  };
  onClick = e => {
    e.stopPropagation();
    this.toggleShown(!this.state.isShown);
  };
  outsideClose = e => {
    if (this.tooltipContent && !this.tooltipContent.contains(e.target)) {
      e.preventDefault();
      this.toggleShown(false);
    }
  };
  onMouseOver = () => this.toggleShown(true);
  onMouseOut = () => this.toggleShown(false);
  toggleShown = isShown => {
    this.setState({
      isShown
    }, () => {
      if (this.state.isShown) {
        document.addEventListener('click', this.outsideClose);
      } else {
        document.removeEventListener('click', this.outsideClose);
      }
    });
    /*
    * TODO: Это заплатка
    * Решает она проблему неправильного отображения тултипа на страницах у которых указана высота
    * body. Например страница где вместо отображения заказов отображается какая то заглушка на 100% высоты.
    */
    if (isShown) {
      makeBodyHeightAuto();
    } else {
      unmakeBodyHeightAuto();
    }
  };
  renderTooltip() {
    const {
      children,
      content,
      placement,
      ...props
    } = this.props;
    const handlers = {};
    if (IS_TOUCHSCREEN) {
      handlers.onClick = this.onClick;
    } else {
      handlers.onMouseOver = this.onMouseOver;
      handlers.onMouseOut = this.onMouseOut;
    }
    return h(Manager, props, /*#__PURE__*/React.createElement("span", {
      ref: node => this.tooltipContent = node
    }, h(Target, handlers, children), this.state.isShown && h(Popper, {
      placement,
      className: 'custom-tooltip',
      onClick: stopPropagation,
      modifiers: Tooltip.popperModifiers
    }, [content, h(Arrow, {
      key: 'arrow',
      className: 'custom-tooltip__arrow'
    })])));
  }
  render() {
    if (!this.state.isReady) return null;
    return this.renderTooltip();
  }
}